import ScrollReveal from 'scrollreveal';

//初回起動時の処理 false
export function pararaFunc() {
    window.sr = ScrollReveal({ reset: false ,mobile: true});
  sr.reveal('.animate',{opacity: 0, duration: 1200,viewFactor: 0.1});
  //sr.reveal('.animate2',{ origin: 'bottom', opacity: 0, duration: 1800,viewFactor: 0});
}


//////////////////
// WEBPACK FOOTER
// ./src/js/common/_parara.js
// module id = 17
// module chunks = 0